import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PasswordGenarationPageComponent } from './pages/password-genaration-page/password-genaration-page.component';

const routes: Routes = [
  {path: 'password-generator', component: PasswordGenarationPageComponent},
  {path: '**', redirectTo: '/password-generator'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
